<template>
  <v-app class="page-container">
    <v-content class="content-wrap">
      <router-view />
    </v-content>
  </v-app>
</template>

<style>
.v-application--wrap {
  min-height: 1vh !important;
}

.gray {
  background-color: #1e1e1e;
}

/* Footer */
.page-container {
  position: relative;
  min-height: 100vh;
}

.content-wrap {
  padding-bottom: 5.5rem; /* Footer height */
}

.page{
  margin-bottom: 5.5rem;
}

.footer {
  position: absolute;
  background: #dd2129;
  bottom: 0;
  width: 100%;
  z-index: 35;
  height: 5.5rem; /* Footer height */
}

/* Fim - Footer */

.banner {
  height: 500px;
  width: 100%;
  background: url("./assets/img/home/banner.jpg");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  mix-blend-mode: multiply;
}

.bannerHeight {
  height: 500px;
}

.footerHeight {
  height: 10px;
}
.grecaptcha-badge {
  z-index: 29;
}

.mapHeight {
  height: 600px;
}

.v-list-scroll {
  height: 600px;
  overflow-y: auto;
}

.v-list-scroll-sm {
  height: 170px;
  overflow-y: auto;
}

.fill {
  height: 100%;
  width: 100%;
}

.fillw {
  width: 100%;
}

.fillh {
  height: 100%;
}

.bImg {
  transform: translate(-50%, 5%);
  filter: blur(30px) brightness(0.9);
  width: 200%;
  position: relative;
  top: -12%;
  left: 50%;
  height: 550px;
}

.bAbsolute {
  position: absolute;
  top: 76px;
  height: 500px;
}

.bCarousel {
  position: absolute;
  top: 0px;
  height: 500px;
}

.boImg {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: contain;
  background-attachment: fixed;
}

.card-actions {
  position: absolute;
  bottom: 0;
}

.darkFilter {
  background: rgba(0, 0, 0, 0.6);
  width: 100%;
  height: 100%;
}

.mr-20 {
  margin-right: 210px;
}
</style>

<script>
export default {
  name: "App",
  async beforeMount() {
    await this.$store.dispatch("setIdiomas");
  }
};
</script>

